var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/react-in-jsx-scope */
import Chart from "component/AuditPrice/Chart";
import { PriceAuditType } from "utils/Enums";
var AuditPriceGraph = function (_a) {
    var _b, _c, _d, _e;
    var translate = _a.translate, graphData = _a.graphData, statusPrice = _a.statusPrice, marginLeft = _a.marginLeft, onExportStore = _a.onExportStore, onExportSection = _a.onExportSection;
    var getIndicators = function () { return [
        {
            color: 'rgba(0, 117, 116, 0.8)',
            description: "Preço correto",
        },
        {
            color: 'rgba(223, 56, 40, 0.8)',
            description: "Preço errado",
        },
        {
            color: '#FC961E',
            description: "Sem preço"
        }
    ]; };
    var _f = getIndicators(), correct = _f[0], wrong = _f[1], without = _f[2];
    var wrapLabel = function (words, maxLength) {
        var mountLine = function (current, add) {
            if (current === void 0) { current = ''; }
            current += add;
            current += ' ';
            return current;
        };
        var lines = words.reduce(function (_a, current) {
            var lines = _a.lines, currentIndex = _a.currentIndex;
            if ("".concat(lines[currentIndex] || '', " ").length + current.length < maxLength) {
                lines[currentIndex] = mountLine(lines[currentIndex], current);
                return { currentIndex: currentIndex, lines: lines };
            }
            currentIndex += 1;
            lines[currentIndex] = mountLine(lines[currentIndex], current);
            return { lines: lines, currentIndex: currentIndex };
        }, { currentIndex: 0, lines: [] }).lines;
        return lines;
    };
    var calculateValuesY = function (data, insertTen) {
        var i = Math.max.apply(Math, data) + 15 - (Math.max.apply(Math, data) % 15);
        if (!data)
            return [];
        if (insertTen) {
            var valuesY = [0, 1, 2, 3,].map(function (multiplicator) { return (i / 3) * multiplicator; });
            if (!valuesY.find(function (value) { return value === 10; }) && Math.max.apply(Math, valuesY) <= 60) {
                var index = valuesY.indexOf(valuesY.find(function (value) { return value > 10; }));
                valuesY.splice(index, 1, 10);
            }
            return valuesY;
        }
        return [0, 1, 2, 3, 4, 5].map(function (multiplicator) { return (i / 5) * multiplicator; });
    };
    var convetStatusPriceToTitle = function () {
        switch (statusPrice) {
            case PriceAuditType.ALL_PRICES:
                return [translate('price.audit.graph.store'), translate('price.audit.graph.section')];
            case PriceAuditType.CORRECT_PRICE:
                return [translate('price.audit.graph.store.correct'), translate('price.audit.graph.section.correct')];
            case PriceAuditType.WRONG_PRICE:
                return [translate('price.audit.graph.store.wrong'), translate('price.audit.graph.section.wrong')];
            default:
                return [translate('price.audit.graph.store.without'), translate('price.audit.graph.section.without')];
        }
    };
    var storeTitle = convetStatusPriceToTitle()[0];
    var sectionTitle = convetStatusPriceToTitle()[1];
    return (_jsxs("div", { children: [_jsx(Chart, { removePadding: true, onExport: onExportStore, marginLeft: marginLeft, t: translate, title: storeTitle, indicators: [correct, wrong, without], data: (_b = graphData.stores) !== null && _b !== void 0 ? _b : [], barSpace: 35, keys: ['correct', 'wrong', 'without'], indexBy: 'store', indicate: true, bar: function (_a, renderLateralIndicator, closeLateralIndicator) {
                    var _b;
                    var value = _a.label, _c = _a.bar, y = _c.y, height = _c.height, color = _c.color, label = _c.label;
                    var _d = label.split(' - '), rest = _d.slice(1);
                    var data = (_b = graphData.stores) !== null && _b !== void 0 ? _b : [];
                    var store = rest.join(' - ');
                    var element = data.find(function (chart) { return chart.store === store; });
                    var index = 0;
                    if (element) {
                        index = data.indexOf(element);
                    }
                    return (_jsx("rect", { cursor: 'pointer', fill: color, width: 28, height: height, x: 15 + (28 + 35) * index, y: y, onMouseEnter: function (e) {
                            return renderLateralIndicator(e, value, index);
                        }, onMouseLeave: closeLateralIndicator }));
                }, axisBottomRender: function (e) {
                    var _a = e.value.split(' - '), id = _a[0], rest = _a.slice(1);
                    var store = rest.join(' - ');
                    return (_jsxs("text", __assign({ alignmentBaseline: e.textBaseline, textAnchor: e.textAnchor }, { children: [_jsx("tspan", __assign({ x: 29 + 63 * e.tickIndex, y: 20, style: {
                                    fontSize: 10,
                                } }, { children: id })), wrapLabel(store.split(' '), 12).map(function (line, i) { return (_jsx("tspan", __assign({ x: 29 + 63 * e.tickIndex, y: 20 + 10 * (i + 1), style: {
                                    fontSize: 10,
                                } }, { children: line }), "".concat(line, "-").concat(i))); })] })));
                }, valuesY: calculateValuesY(((_c = graphData.stores) !== null && _c !== void 0 ? _c : []).map(function (_a) {
                    var correct = _a.correct, without = _a.without, wrong = _a.wrong;
                    return correct + without + wrong;
                }), false), axisLeftRender: function (e) { return (_jsx("text", __assign({ alignmentBaseline: e.textBaseline, textAnchor: e.textAnchor }, { children: _jsx("tspan", __assign({ x: e.x - 10, y: e.y + 3, style: {
                            fontSize: 10,
                        } }, { children: e.value })) }))); } }), _jsx(Chart, { removePadding: true, onExport: onExportSection, marginLeft: marginLeft + 15, t: translate, title: sectionTitle, indicators: [correct, wrong, without], data: (_d = graphData.sections) !== null && _d !== void 0 ? _d : [], barSpace: 35, keys: ['correct', 'wrong', 'without'], indexBy: 'section', indicate: true, bar: function (_a, renderLateralIndicator, closeLateralIndicator) {
                    var _b;
                    var value = _a.label, _c = _a.bar, y = _c.y, height = _c.height, color = _c.color, label = _c.label;
                    var _d = label.split(' - '), rest = _d.slice(1);
                    var data = (_b = graphData.sections) !== null && _b !== void 0 ? _b : [];
                    var store = rest.join(' - ');
                    var element = data.find(function (chart) { return chart.section === store; });
                    var index = 0;
                    if (element) {
                        index = data.indexOf(element);
                    }
                    return (_jsx("rect", { cursor: 'pointer', fill: color, width: 28, height: height, x: 15 + (28 + 35) * index, y: y, onMouseEnter: function (e) {
                            return renderLateralIndicator(e, value, index);
                        }, onMouseLeave: closeLateralIndicator }));
                }, axisBottomRender: function (e) {
                    var _a = e.value.split(' '), id = _a[0], rest = _a.slice(1);
                    var fixedSection = ["laminados", "e vinilicos"];
                    var store = rest.join(' ');
                    return (_jsxs("text", __assign({ alignmentBaseline: e.textBaseline, textAnchor: e.textAnchor }, { children: [_jsx("tspan", __assign({ x: 29 + 63 * e.tickIndex, y: 25, style: {
                                    fontSize: 10,
                                } }, { children: id })), e.value !== "Pisos laminados e vinilicos" ? wrapLabel(store.split(' '), 12).map(function (line, i) { return (_jsx("tspan", __assign({ x: 29 + 63 * e.tickIndex, y: 25 + 10 * (i + 1), style: {
                                    fontSize: 10,
                                } }, { children: line }), "".concat(line, "-").concat(i))); }) : fixedSection.map(function (line, i) { return (_jsx("tspan", __assign({ x: 29 + 63 * e.tickIndex, y: 25 + 10 * (i + 1), style: {
                                    fontSize: 10,
                                } }, { children: line }), "".concat(line, "-").concat(i))); })] })));
                }, valuesY: calculateValuesY(((_e = graphData.sections) !== null && _e !== void 0 ? _e : []).map(function (_a) {
                    var correct = _a.correct, without = _a.without, wrong = _a.wrong;
                    return correct + without + wrong;
                }), false), axisLeftRender: function (e) { return (_jsx("text", __assign({ alignmentBaseline: e.textBaseline, textAnchor: e.textAnchor }, { children: _jsx("tspan", __assign({ x: e.x - 10, y: e.y + 3, style: {
                            fontSize: 10,
                        } }, { children: e.value })) }))); } })] }));
};
export default AuditPriceGraph;
